import React, { Suspense, useState, useEffect, useRef, useLayoutEffect } from 'react'
import '../style.css'
import ExperienceContainer from '../components/ExperienceContainer'
import TourSection from './TourSection';
import LatestButton from '../components/LatestButton';
import ScrollDown from '../components/ScrollDown';
import { AnimatePresence, motion, useScroll, useTransform, useMotionValue, useSpring, useAnimation } from 'framer-motion';
import Galantis from './Galantis';
import Footer from './Footer';
import LatestSection from './LatestSection';
import { client } from '../client'
import ByManta from './ByManta';
import Copyright2 from './Copyright2';
import irridescent from '../assets/irridescent.png'
import overlayhd from '../assets/overlayhd.webp'
import tdtrstickerwhite from '../assets/tdtrstickerwhite.png'
import tdtryellowsticker from '../assets/tdtrstickeryellow.png'
import stay800 from '../assets/stay800.jpg'
import YG from './YG';
import '../css/latest-release.css'
import vid from '../assets/stayloop.mp4'
import { useInView } from 'react-intersection-observer';
import covers2000 from '../assets/covers2000.jpg'
import Music2 from './Music2';
import AboutSection from './AboutSection';
import MerchSection from './MerchSection';
import TDTR from './TDTR';
import Copyright4 from './Copyright4';
import ByManta2 from './ByManta2';
import { useLocation } from 'react-router-dom';

const Home = ({ overlay, setOverlay, windowWidth, setInView, mode }) => {

  const [ latest, setLatest ] = useState([0])
  const [ smart, setSmart ] = useState()
  const [ latestImage, setLatestImage ] = useState([0]) 
  const spacerRef = useRef()
  const contentRef = useRef()
  const innerRef = useRef(null) 
  const [ ref, inView ] = useInView()
  const [ ref2, inView2 ] = useInView()
  const { pathname } = useLocation()

  const [isRevealed, setIsRevealed] = useState(false);



  // let { scrollY } = useScroll()
  // let opacity = useTransform(scrollY, [0, 2000], [1, 1])

// useLayoutEffect(() => {
//   const h = innerRef.current.getBoundingClientRect().height
//   spacerRef.current.style.height = `${h}px`
//   console.log(h)
// }, [])

useLayoutEffect(() => {
    const el = innerRef.current;
    if (!el) return;

    const update = () => {
      const h = el.getBoundingClientRect().height;
      spacerRef.current.style.height = `${h}px`;
    };

    update(); // initial

    const observer = new ResizeObserver(update);
    observer.observe(el);

    return () => observer.disconnect();
  }, []);


const { scrollY } = useScroll();

useEffect(() => {
  if (pathname === '/tour') {
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 350, 
        behaviour: 'smooth',
      })
    }, 500)

    return () => clearTimeout(timer)
  }
}, [ pathname ])

  // Smooth the scroll
  const smoothY = useSpring(scrollY, {
    damping: 40,
    stiffness: 200,
    mass: 0.2,
  });

  const inverted = useTransform(smoothY, v => -v)
  const slower = useTransform(smoothY, v => -v * 0.3)
  const down = useTransform(smoothY, v => v * 0.3)

  const y = useTransform(smoothY, v => {
    const start = 600
    const speed = 0.7
  
    if (v < start) return 0
    return -(v - start) * speed
  })

  useEffect(() => {
    setInView(inView);
  }
, [inView])

// 🔥 Reset when Home unmounts (route change)
useEffect(() => {
  return () => {
    setInView(false);
  };
}, []);


  useEffect(() => {
    client.fetch(`*[_type == "latestrelease"]{
        smarturl,
        "imageUrl": image.asset->url,
    }`)
    .then((data) => setLatest(data))
    .catch(console.error)
}, [])

useEffect(() => {
    const initUrl = async () => {
        await latest
        setSmart(latest[0].smarturl)
        setLatestImage(latest[0].imageUrl)
    }
    initUrl()
}, [latest]) 


 
  return (
    <>
    <AnimatePresence mode="wait">
    {/* <Popup /> */}
      <div style={{ position: 'fixed', zIndex: 0 }}>

          <YG mode={ mode } smoothY={ smoothY } inverted={ inverted } inView={ inView } />


        <motion.img 
        // initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { duration: 0.7, delay: 4 } }}
         src={ covers2000 } style={{ position: 'fixed', width: '100vw', height: '100vh', top: 0, objectFit: 'cover', opacity: isRevealed ? 1 : 0 }} />
        
        
          <LatestButton smart={ smart } scrollY={ scrollY } windowWidth={  windowWidth } />

        <Copyright4 />
        <ByManta2 />
        <Footer inView2={ inView2 } /> 

        {/* <Music2 /> */}

        <ScrollDown down={ down } />
        <motion.div>
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { duration: 0.7, delay: 3 } }} style={{ position: 'fixed', top: '85vh', left: '10vw', zIndex: 3, y: down }}>
                <img src={ irridescent } style={{ width: 'clamp(140px, 20vw, 300px)' }} />
              </motion.div>
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { duration: 0.7, delay: 3 } }} style={{ position: 'fixed', top: '0.5vh', right: '29vw',  zIndex: 3, y: slower }}>
                <img src={ tdtrstickerwhite } style={{ width: 'clamp(170px, 20vw, 300px)' }} />
              </motion.div>
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { duration: 0.7, delay: 3 } }} style={{ position: 'fixed', top: '-1vh', right: '25vw',  zIndex: 3, y: slower }}>
                <img src={ tdtryellowsticker } style={{ width: 'clamp(170px, 20vw, 300px)' }} />
              </motion.div>
              <div style={{ position: 'fixed', width: '100vw', height: '100vh', zIndex: 500, pointerEvents: 'none', opacity: 0.05 }}>
                  <img src={ overlayhd } style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
        </motion.div>

        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { duration: 0.7, delay: 3 } }} style={{ width: '100vw', height: '100vh', position: 'fixed', y }}>
                <motion.video id='myVideo' autoPlay loop muted playsInline style={{ height: '100vh', width: '100vw', objectFit: 'cover', zIndex: 1, opacity: 1 }}>
                  <source src={ vid } type="video/mp4"></source>
              </motion.video>
        </motion.div>

          
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { duration: 0.7, delay: 3 } }} ref={ contentRef } style={{ position: 'relative', y: inverted, zIndex: 5 }}>
          <div ref={ innerRef }>

              <div ref={ ref } style={{ height: '15vh', width: '100%', position: 'absolute', pointerEvents: 'none' }}></div>
              <div style={{ width: '100vw', height: '150vh', pointerEvents: 'none', position: 'relative' }}></div>

              <TourSection />
              <LatestSection setIsRevealed={setIsRevealed} smart={ smart } latestImage={ latestImage } overlay={ overlay } setOverlay={ setOverlay } />
              <AboutSection windowWidth={ windowWidth } smoothY={ smoothY } />
              <MerchSection windowWidth={ windowWidth } />
              <TDTR />
              <div ref={ ref2 } style={{ width: '10px', height: '1px', marginTop: '-1px' }}></div>
              
          </div>
        </motion.div>
      </div>
      <div className='spacer' style={{ position: 'relative', pointerEvents: 'none' }} ref={spacerRef}></div>
    </AnimatePresence>
      </>
  )
}

export default Home